<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <b-form @submit="onSubmit" @reset="onReset" novalidate="novalidate">
                    <div class="card">
                        <div class="card-header card-header-icon card-header-rose">
                            <div class="card-icon">
                                <i class="material-icons">search</i>
                            </div>
                            <h4 class="card-title">Filtros</h4>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-3">
                                    <div class="form-group bmd-form-group">
                                        <model-list-select 
                                            class="form-control"
                                            :list="functionalities"     
                                            option-value="id"
                                            option-text="name"
                                            v-model="form.functionality_id">
                                        </model-list-select>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group bmd-form-group">
                                        <model-list-select 
                                            class="form-control"
                                            :list="actions"     
                                            option-value="id"
                                            option-text="name"
                                            v-model="form.action_id">
                                        </model-list-select>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group bmd-form-group">
                                        <model-list-select 
                                            class="form-control"
                                            :list="users"     
                                            option-value="id"
                                            option-text="name"
                                            v-model="form.user_id">
                                        </model-list-select>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group bmd-form-group" v-bind:class="{'is-filled': form.register_id != ''}">
                                        <label for="register_id" class="bmd-label-floating">Registro</label>
                                        <input refs="register" type="text" class="form-control" v-model="form.register_id" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer">
                            <button type="reset" class="btn btn-fill btn-outline-danger">Limpar</button>
                            <button type="submit" class="btn btn-fill btn-rose">Filtar</button>
                        </div>
                    </div>
                </b-form>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header card-header-icon card-header-rose">
                        <div class="card-icon">
                            <i class="material-icons">list</i>
                        </div>
                        <h4 class="card-title ">Lista</h4>
                    </div>
                    <div class="card-body">
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th class="text-center">#</th>
                                        <th>Usuário</th>
                                        <th>Funcionalidade</th>
                                        <th>Ação</th>
                                        <th>Registro</th>
                                        <th>Valor Anterior</th>
                                        <th>Novo Valor</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr 
                                        v-for="iterator in audits"
                                        v-show="audits.length > 0"
                                        :key="iterator.id">
                                        <td class="text-center">{{ iterator.id }}</td>
                                        <td>{{ iterator.user != null ? iterator.user.name : 'Sistema' }}</td>
                                        <td>{{ iterator.functionality.name }}</td>
                                        <td>{{ iterator.action.name }}</td>
                                        <td>{{ iterator.register_id }}</td>
                                        <td>
                                            <pre v-if="iterator.last_value">{{ iterator.last_value | jsonparse }}</pre>
                                        </td>
                                        <td>
                                            <pre v-if="iterator.new_value">{{ iterator.new_value | jsonparse }}</pre>
                                        </td>
                                    </tr>
                                    <tr v-show="audits.length==0">
                                        <td colspan="7">Nenhuma auditoria encontrada!</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="card-footer">
                        <b-pagination
                            order="is-right"
                            v-show="audits.length > 0"
                            v-model="currentPage"
                            :simple="false"
                            :per-page="limit"
                            :total-rows="total"
                            @change="pageChange">
                        </b-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script scoped>
    import ActionService from '@/services/modules/actions.service';
    import AuditService from '@/services/modules/audits.service';

    export default {
        data() {
            return {
                actions: [],
                audits: [],
                currentPage: 1,
                form: {
                    action_id: '',
                    functionality_id: '',
                    user_id: '',
                    register_id: ''
                },
                functionalities: [],
                limit: 5,
                total: 0,
                users: []
            }
        },
        methods: {
            async getActions() {
                var self = this;

                self.$root.$emit("onLoading");

                const action = ActionService.get();

                action.then(function (_list) {
                    self.actions = _list;
                    
                    self.actions.unshift({id: '', name: 'Ações'});

                    self.$root.$emit("onLoading");
                    self.getUsers();
                });

                action.catch(function () {
                    self.$root.$emit("onLoading");
                    self.$notify.error("Falha na comunicação com a API!");
                });
            },
            async getData() {
                var self = this;

                self.$root.$emit("onLoading");

                const response = AuditService.get(self.limit, self.currentPage, self.form);

                response.then(function (_pagination) {
                    self.audits = _pagination.data;

                    self.total = _pagination.total;

                    self.$root.$emit("onLoading");
                });

                response.catch(function () {
                    self.$root.$emit("onLoading");
                    self.$notify.error("Falha na comunicação com a API!");
                });
            },
            async getFuncionalities() {
                var self = this;

                self.$root.$emit('onLoading');

                const response = self.$store.dispatch('functionalities/all');

                response.then(function () {
                    self.functionalities = self.$store.state.functionalities.itens;
                    
                    self.functionalities.unshift({id: '', name: 'Funcionalidades'});
                    
                    self.$root.$emit('onLoading');

                    self.getActions();
                });

                response.catch(function () {
                    self.$root.$emit('onLoading');
                    self.$notify.error("Falha na comunicação com a API!");
                });
            },
            async getUsers() {
                var self = this;

                self.$root.$emit("onLoading");

                const response = self.$store.dispatch("users/all");

                response.then(function () {
                    self.users = self.$store.state.users.itens;
                    
                    self.users.unshift({id: '', name: 'Usuários'});
                    
                    self.$root.$emit('onLoading');

                    self.getData();
                });

                response.catch(function () {
                    self.$root.$emit('onLoading');
                    self.$notify.error("Falha na comunicação com a API!");
                });
            },
            pageChange(_pageNum) {
                var self = this;

                self.currentPage = _pageNum;
                
                var router = {
                    name: "audits.index",
                    query: {
                        page: _pageNum,
                        functionality: self.$route.query.functionality ? parseInt(self.$route.query.functionality) : '',
                        action: self.$route.query.action ? parseInt(self.$route.query.action) : '',
                        user: self.$route.query.user ? parseInt(self.$route.query.user) : '',
                        register: self.$route.query.register_id ? parseInt(self.$route.query.register) : ''
                    }
                };

                self.$router.push(router);

                self.getData();
            },
            onReset(_evt) {
                _evt.preventDefault();
                
                var self = this;
                
                self.form.functionality_id = '';
                self.form.action_id = '';
                self.form.user_id = '';
                self.form.register_id = '';
            },
            onSubmit(_evt) {
                _evt.preventDefault();
                
                var self = this;
                var router = {
                    name: "audits.index",
                    query: {
                        functionality: self.form.functionality_id,
                        action: self.form.action_id,
                        user: self.form.user_id,
                        register: self.form.register_id 
                    }
                };
                
                self.$router.push(router);
                
                self.getData();
            }
        },
        mounted() {
            var self = this;

            self.currentPage = self.$route.query.page ? parseInt(self.$route.query.page) : 1;
            
            self.form.functionality_id = self.$route.query.functionality ? parseInt(self.$route.query.functionality) : '';
            self.form.action_id = self.$route.query.action ? parseInt(self.$route.query.action) : '';
            self.form.user_id = self.$route.query.user ? parseInt(self.$route.query.user) : '';
            self.form.register_id = self.$route.query.register ? parseInt(self.$route.query.register) : '';
            
            self.getFuncionalities();
        }
    };
</script>

<style scoped>
    pre {
        box-shadow: none;
        -webkit-box-shadow: none;
    }
</style>